var rtlStyles = {"rtl":"ocOWm","ltr":"GbeMX"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-ac257d76.js.map
